export default class GeneralEmailMessageRequestData {
  public subject: string
  public html_content: string

  public constructor (subject: string, htmlContent: string) {
    this.subject = subject
    this.html_content = htmlContent
  }
}
